import {Component, Input, OnInit} from '@angular/core';
import {ModalWindowComponent} from '../../std-components/modal-window/modal-window.component';
import {BuildingOtherRooms, ISpot, RoomTypeItem} from '../../shared/models/models';
import {ServerService} from '../../shared/services/server.service';
import {EventService} from '../../shared/services/event.service';
import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";

@Component({
	selector: 'app-commercial-premises',
	templateUrl: './commercial-premises.component.html',
	styleUrls: [ './commercial-premises.component.scss' ],
  standalone: true,
  imports: [CommonModule, FormsModule]
})
export class CommercialPremisesComponent implements OnInit {
	@Input() spotObjectAddAppartments: ISpot;

	onchangeModel = false;
	commercialPremisesTypes: RoomTypeItem[] = [];
	buildingOtherRooms: BuildingOtherRooms;
	buildingOtherRoomsSet: BuildingOtherRooms[] = [];

	constructor(private modalWindow: ModalWindowComponent, private serverService: ServerService, private event: EventService) {}

	ngOnInit() {
		this.buildingOtherRooms = {
			BuildingID: this.spotObjectAddAppartments.id,
			Delete: false,
			Area: 0,
			RoomTypeItemID: null,
			PlaceCount: 0,
			PhotoFileID: 0
		};
		if (this.spotObjectAddAppartments.commercialRooms.length > 0) {
			for (let rooms of this.spotObjectAddAppartments.commercialRooms) {
				this.commercialPremisesTypes.push(Object.assign({}, rooms));
			}
		}
	}

	changedModel() {
		this.onchangeModel = true;
	}

	cancel() {
		this.commercialPremisesTypes = [];
		this.buildingOtherRooms = null;
		this.buildingOtherRoomsSet = [];
		this.modalWindow.closeModalWindow();
	}
	saveState() {
		for (let i = 0; i < this.commercialPremisesTypes.length; i++) {

			if (!this.commercialPremisesTypes.find(x => x.id === 101).checked) {
                this.commercialPremisesTypes.find(x => x.id === 10101).checked = false;
                this.commercialPremisesTypes.find(x => x.id === 10102).checked = false;
			}

			if (this.commercialPremisesTypes.find(x => x.id === 101).checked && !this.commercialPremisesTypes.find(x => x.id === 10101).checked && !this.commercialPremisesTypes.find(x => x.id === 10102).checked) {
                this.commercialPremisesTypes.find(x => x.id === 101).checked = false;
			}

			if (!this.commercialPremisesTypes.find(x => x.id === 103).checked) {
                this.commercialPremisesTypes.find(x => x.id === 10301).checked = false;
                this.commercialPremisesTypes.find(x => x.id === 10302).checked = false;
			}

			if (this.commercialPremisesTypes.find(x => x.id === 103).checked && !this.commercialPremisesTypes.find(x => x.id === 10301).checked && !this.commercialPremisesTypes.find(x => x.id === 10302).checked) {
                this.commercialPremisesTypes.find(x => x.id === 103).checked = false;
			}

			this.spotObjectAddAppartments.commercialRooms[i].checked = this.commercialPremisesTypes[i].checked;

			this.buildingOtherRooms.RoomTypeItemID = this.commercialPremisesTypes[i].id;
			this.buildingOtherRooms.Area = this.commercialPremisesTypes[i].area;
			this.buildingOtherRooms.Delete = !this.commercialPremisesTypes[i].checked;
      this.buildingOtherRooms.PlaceCount = this.commercialPremisesTypes[i].placeCount;
			this.buildingOtherRoomsSet.push(Object.assign({}, this.buildingOtherRooms));
			if (this.commercialPremisesTypes[i].subItems != null) {
				for (let j = 0; j < this.commercialPremisesTypes[i].subItems.length; j++) {
					this.spotObjectAddAppartments.commercialRooms[i].subItems[j].checked = this.commercialPremisesTypes[i].subItems[j].checked;
					this.buildingOtherRooms.RoomTypeItemID = this.commercialPremisesTypes[i].subItems[j].id;
					this.buildingOtherRooms.Delete = !this.commercialPremisesTypes[i].subItems[j].checked;
					this.buildingOtherRoomsSet.push(Object.assign({}, this.buildingOtherRooms));
				}
			}
	}

    this.setOtherRoooms(this.buildingOtherRoomsSet);
    this.event.initialize.emit(this.spotObjectAddAppartments);
	}

	setOtherRoooms(buildingRoom) {
		this.serverService.setBuildingOtherRoomsWf(buildingRoom).then((res) => {
			this.cancel();
		});
	}
}
